import { useCallback } from 'react';

import { useFindComponentDimensions } from '../component.hooks';
import { useFileDropperContext } from 'lib/form/file-dropper/file-dropper';
import { ACCEPT_TYPE_RIVE } from 'lib/form/file-dropper/file-dropper.constants';
import { FileDropperRive } from './file-dropper-rive';
import { ImageCreateFieldWrapper } from '../image/image.style';

const RIVE_FILE_KEY = 'riveFileKey';

const RiveEditUpload = ({
  id,
  onShowModal,
}: {
  id: string;
  onShowModal: (props: { key: string; fileName: string; file: File }) => void;
}) => {
  const { clearFile } = useFileDropperContext(RIVE_FILE_KEY);

  const { elementDimensionLabel } = useFindComponentDimensions(id);

  const handleFileChange = useCallback(
    ({
      key,
      fileName,
      file,
    }: {
      key: string;
      fileName: string;
      file: File;
    }) => {
      clearFile();
      onShowModal({ key, fileName, file });
    },
    [clearFile, onShowModal]
  );

  return (
    <ImageCreateFieldWrapper>
      <FileDropperRive
        name={RIVE_FILE_KEY}
        inputDataSelector="rive-file-upload"
        accept={[ACCEPT_TYPE_RIVE]}
        isFinishing={false}
        additionalLabel={elementDimensionLabel}
        onChange={handleFileChange}
      />
    </ImageCreateFieldWrapper>
  );
};

export default RiveEditUpload;
